export const FETCH_DOC_BEGIN="FETCH_DOC_BEGIN";
export const FETCH_DOC_SUCCESS="FETCH_DOC_SUCCESS";
export const FETCH_DOC_FAILURE="FETCH_DOC_FAILURE";

export const FETCH_MULTIPLEDOCS_BEGIN="FETCH_MUTILPLEDOCS_BEGIN";
export const FETCH_MULTIPLEDOCS_SUCCESS="FETCH_MUTILPLEDOCS_SUCCESS";
export const FETCH_MULTIPLEDOCS_FAILURE="FETCH_MUTILPLEDOCS_FAILURE";

export const FETCH_DOCDETAILS_BEGIN="FETCH_DOCDETAILS_BEGIN";
export const FETCH_DOCDETAILS_SUCCESS="FETCH_DOCDETAILS_SUCCESS";
export const FETCH_DOCDETAILS_FAILURE="FETCH_DOCDETAILS_FAILURE";